import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container", "template", "root"]

  connect() {
    // index for new child indexes (use container children count)
    this.index = this.containerTarget.children.length
    // initialize all existing rule-items on page load
    this.initializeAll()
  }

  // Add new rule: clone server-rendered template, replace NEW_RECORD, insert
  addRule() {
    const templateHTML = this.templateTarget.innerHTML
    const newHTML = templateHTML.replace(/NEW_RECORD/g, this.index)
    this.index++
    this.containerTarget.insertAdjacentHTML("beforeend", newHTML)

    // After insert, initialize that new rule (toggle fields)
    const newRule = this.containerTarget.lastElementChild
    this.toggleRuleElement(newRule)
    // ensure task_action_rules_all visible if required
    this.updateRulesAllVisibility()
  }

  // Mark rule for destruction: set hidden _destroy to 1 and hide visually
  removeRule(event) {
    const wrapper = event.target.closest(".rule-item")
    if (!wrapper) return
    const destroyField = wrapper.querySelector('input.destroy-flag')
    if (destroyField) {
      destroyField.value = "1"
    }
    // hide visually
    wrapper.style.display = "none"
    this.updateRulesAllVisibility()
  }

  // change handler (delegated) - event.target is the select that changed
  toggle(event) {
    // when called as event handler, event.target is the select
    if (event && event.target) {
      const wrapper = event.target.closest(".rule-item")
      if (wrapper) this.toggleRuleElement(wrapper)
    } else {
      // no event — toggle all (used on init)
      this.initializeAll()
    }

    this.updateRulesAllVisibility()
  }

  // Initialize all current rule items (on connect or when needed)
  initializeAll() {
    const ruleItems = Array.from(this.containerTarget.querySelectorAll(".rule-item"))
    ruleItems.forEach(item => this.toggleRuleElement(item))
  }

  // Toggle a single rule-item element's groups: show matching group and enable inputs
  toggleRuleElement(wrapper) {
    if (!wrapper) return
    const select = wrapper.querySelector("select[name*='rule_type']")
    const selectedType = select ? select.value : null

    // find all groups inside this wrapper (data-field-group)
    const groups = Array.from(wrapper.querySelectorAll("[data-field-group]"))

    groups.forEach(group => {
      const matches = group.dataset.fieldGroup === selectedType
      group.style.display = matches ? "block" : "none"

      // enable inputs only if matches; disabled inputs won't be submitted
      const inputs = Array.from(group.querySelectorAll("input, select, textarea"))
      inputs.forEach(input => {
        input.disabled = !matches
      })
    })
  }

  // Decide whether to show the task_action_rules_all UI (example logic)
  updateRulesAllVisibility() {
    // find any visible non-destroyed rule-item
    const items = Array.from(this.containerTarget.querySelectorAll(".rule-item"))
    const anyVisible = items.some(item => {
      // ignore those with destroy-flag=1
      const destroyField = item.querySelector('input.destroy-flag')
      if (destroyField && destroyField.value === "1") return false
      // and are not display:none
      return item.style.display !== "none"
    })

    const field = document.querySelector(".task_action_rules_all")
    if (field) {
      field.style.display = anyVisible ? "block" : "none"
    }
  }
}
